import { Button } from "@/components/ui/button";
import { FESTIVAL_KIND_LABEL } from "@/lib/tina/festivals";

interface KindSwitchProps {
  kind: string;
  disabled: boolean;
  /** The curator asked for the other kind; the page confirms it before anything is sent. */
  onAsk: (to: "day_ticket" | "program") => void;
}

/** Two buttons in one bordered group: the festival's type, the active one filled. */
export function KindSwitch({ kind, disabled, onAsk }: KindSwitchProps) {
  const options = ["day_ticket", "program"] as const;
  return (
    <div className="flex items-center gap-3">
      <div className="inline-flex overflow-hidden rounded-md border">
        {options.map((option) => (
          <Button
            key={option}
            type="button"
            size="sm"
            variant={kind === option ? "default" : "ghost"}
            className="rounded-none"
            disabled={disabled}
            aria-pressed={kind === option}
            onClick={() => {
              if (kind !== option) onAsk(option);
            }}
          >
            {FESTIVAL_KIND_LABEL[option]}
          </Button>
        ))}
      </div>
      <span className="text-xs text-muted-foreground">
        Day ticket: one event per day. Program: many separate concerts.
      </span>
    </div>
  );
}
